import { render, staticRenderFns } from "./undangan-pengajian.vue?vue&type=template&id=45f45e5a&"
import script from "./undangan-pengajian.vue?vue&type=script&lang=js&"
export * from "./undangan-pengajian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports